<fc-general-modal [baseId]="baseId"
                  [form]="form"
                  [fcModalItemContext]="fcModalItemContext"
                  (saveForm)="save()"
                  (cancelForm)="onCancel()">
  <div [formGroup]="form">
    <mat-tab-group animationDuration="0ms"
                   mat-align-tabs="start"
                   class="tabs-default full-modal-tabs"
                   [disableRipple]="true">
      <mat-tab>
        <ng-template mat-tab-label>
          <span class="tab-label"
                translate>General</span>
        </ng-template>
        <div class="form-group full-control">
          <label for="{{ baseId }}-name"
                 translate>Name</label>
          <input #name
                 id="{{ baseId }}-name"
                 class="form-control"
                 [ngClass]="{ error: showErrors(nameControl, isSubmitted), 'required': isRequired(nameControl) }"
                 type="text"
                 formControlName="name" />
          <div *ngIf="showErrors(nameControl, isSubmitted)"
               class="incorrect-input"
               id="{{ baseId }}-warning-text-name"
               translate>
            {{ nameControl.errors | fcListValidation : 'Name' }}
          </div>
        </div>

        <div class="form-group full-control">
          <label for="{{ baseId }}-notes"
                 translate>Notes</label>
          <textarea class="form-control"
                    [ngClass]="{ error: showErrors(notesControl, isSubmitted), 'required': isRequired(notesControl) }"
                    id="{{ baseId }}-notes"
                    formControlName="notes"
                    rows="3">
          </textarea>
          <div *ngIf="showErrors(notesControl, isSubmitted)"
               id="{{ baseId }}-warning-text-notes"
               class="incorrect-input"
               translate>
            {{ notesControl.errors | fcListValidation : 'Notes' }}
          </div>
        </div>

        <div class="form-group checkbox-group full-control">
          <mat-checkbox id="{{ baseId }}-inactive-checkbox"
                        formControlName="inactive"
                        translate> Inactive</mat-checkbox>
          <mat-checkbox id="{{ baseId }}-user-defined-checkbox"
                        formControlName="userDefined"
                        translate> User Defined</mat-checkbox>
        </div>

        <div #tableContainer
             cdkScrollable
             class="hidden-scroll"
             [style.height.px]="tableHeight">
          <table class="table emds-table table-sticky-header table-flush-bottom">
            <thead>
              <tr>
                <th>&nbsp;</th>
                <th>Label</th>
                <th></th>
              </tr>
            </thead>
            <tbody formArrayName="checkList"
                   cdkDropList
                   (cdkDropListDropped)="drop($event)"
                   cdkDropListAutoScrollStep="5"
                   class="list-container">
              <tr *ngFor="let row of checkListFormArray.controls; let i = index"
                  [formGroupName]="i"
                  cdkDragBoundary=".list-container"
                  cdkDrag
                  cdkDragLockAxis="y"
                  [cdkDragDisabled]="checkListFormArray.controls.length < 2"
                  class="list-box cdk-drag">
                <td>
                  <mat-icon class="drag-handle"
                            cdkDragHandle>drag_handle</mat-icon>
                </td>
                <td>
                  <div class="form-group">
                    <input #inputLabel
                           id="{{ baseId }}-check-list-{{i}}-label"
                           formControlName="labelFormControl"
                           class="form-control"
                           [ngClass]="{  error: showErrors(checkListFormArray.controls[i]?.get('labelFormControl'), isSubmitted),  'required': true }" />
                    <div *ngIf="showErrors(checkListFormArray.controls[i]?.get('labelFormControl'), isSubmitted)"
                         id="{{ baseId }}-check-list-{{i}}-label-error"
                         class="incorrect-input"
                         translate>
                      {{ checkListFormArray.controls[i]?.get('labelFormControl')?.errors | fcListValidation : 'Label'}}
                    </div>
                    <ng-template cdkDragPreview>
                      <input [value]="checkListFormArray.controls[i].get('labelFormControl')?.value"
                             readonly />
                    </ng-template>
                  </div>
                </td>
                <td>
                  <mat-icon (click)="removeItem(i)">close</mat-icon>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="add-item">
          <mat-icon (click)="addItem()">add_circle</mat-icon>
        </div>

      </mat-tab>
    </mat-tab-group>
  </div>
</fc-general-modal>
